import { createSlice, PayloadAction } from "@reduxjs/toolkit"
import { CampoDinamico, DadosConvite } from "../interfaces/CampoDinamico"
import { Convite, IGeoLocalizacao } from "../interfaces/Convite"
import { LivenessResult } from "../interfaces/LivenessResult"

interface State {
    convite: Convite | null
    conviteCampos: CampoDinamico[] | null
    geoLocalizacao: IGeoLocalizacao | null
    foto: string | null
    dadosConvite: DadosConvite | null
    sessionId: string | null
    validateLivenessResult: LivenessResult | null
}

const initialState: State = {
    convite: null,
    conviteCampos: null,
    geoLocalizacao:  null,
    foto: null,
    dadosConvite: null,
    sessionId: null,
    validateLivenessResult: null
}

const conviteSlice = createSlice({
    name: 'convite',
    initialState,
    reducers: {
        setConvite: (state, action: PayloadAction<State['convite']>) => {
            state.convite = action.payload
        },
        setConviteCampos: (state, action: PayloadAction<State['conviteCampos']>) => {
            state.conviteCampos = action.payload
        },
        setGeoLocalozacao: (state, action: PayloadAction<State['geoLocalizacao']>) => {
            state.geoLocalizacao = action.payload
        },
        setFoto: (state, action: PayloadAction<State['foto']>) => {
            state.foto = action.payload
        },
        setDadosConvite: (state, action: PayloadAction<State['dadosConvite']>) => {
            state.dadosConvite = action.payload
        },
        setSessionId: (state, action: PayloadAction<State['sessionId']>) => {
            state.sessionId = action.payload
        },
        setValidateLiveness: (state, action: PayloadAction<LivenessResult>) => {
            state.validateLivenessResult = action.payload
        },
    }
})

export const { setValidateLiveness, setSessionId, setConvite, setConviteCampos,setGeoLocalozacao, setFoto, setDadosConvite } = conviteSlice.actions
export default conviteSlice.reducer